(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PasswordChangeDialogController', PasswordChangeDialogController);

    PasswordChangeDialogController.$inject = ['$uibModalInstance', 'Auth', 'Principal'];

    function PasswordChangeDialogController($uibModalInstance, Auth, Principal) {
        var vm = this;


        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        vm.changePassword = changePassword;
        vm.clear = clear;

        Principal.identity().then(function(account){
           vm.account = account;
        });

        function changePassword() {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
